var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashbackrewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 30,
    r: 23,
    fill: "#B5D7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.6042 23.6206H12.0098V44.8029H56.6042V23.6206Z",
    fill: "#166BCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7061 30.7815V37.6422C16.557 37.9297 18.8263 40.1877 19.1311 43.0335H49.9394C50.2278 40.3413 52.2743 38.1751 54.9082 37.7057V30.718C52.2743 30.2486 50.2278 28.0824 49.9394 25.3901H19.1311C18.8263 28.2359 16.557 30.494 13.7061 30.7815Z",
    fill: "#7EB3F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M55.4893 23.6206H12.0098V43.6881H55.4893V23.6206Z",
    fill: "#166BCD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3742 21.3906H9.77979V42.5729H54.3742V21.3906Z",
    fill: "#166BCD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4761 28.5516V35.4123C14.327 35.6998 16.5962 37.9577 16.9011 40.8035H47.7094C47.9978 38.1113 50.0443 35.9452 52.6781 35.4758V28.4881C50.0442 28.0187 47.9977 25.8524 47.7094 23.1602H16.9011C16.5964 26.006 14.3271 28.2641 11.4761 28.5516Z",
    fill: "#7EB3F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M53.2593 21.3906H9.77979V41.4581H53.2593V21.3906Z",
    fill: "#166BCD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1447 19.1611H7.55029V40.3434H52.1447V19.1611Z",
    fill: "#328CE1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24658 24.988V32.5948C12.5429 32.6264 15.2116 35.2825 15.2633 38.574H44.3312C44.3832 35.2627 47.0837 32.5945 50.4073 32.5945C50.4211 32.5945 50.4349 32.5946 50.4486 32.5946V25.0169C48.4499 24.4614 46.8657 22.9099 46.2643 20.9307H13.3302C12.739 22.8766 11.1978 24.409 9.24658 24.988Z",
    fill: "#7EB3F1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9072 38.0311C33.9094 38.0311 37.1538 34.4124 37.1538 29.9484C37.1538 25.4844 33.9094 21.8657 29.9072 21.8657C25.905 21.8657 22.6606 25.4844 22.6606 29.9484C22.6606 34.4124 25.905 38.0311 29.9072 38.0311Z",
    fill: "#328CE1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M44.9603 29.1952C44.9603 30.7691 43.6844 32.0449 42.1105 32.0449C40.5366 32.0449 39.2607 30.7691 39.2607 29.1952C39.2607 27.6213 40.5366 26.3454 42.1105 26.3454C43.6844 26.3454 44.9603 27.6213 44.9603 29.1952Z",
    fill: "#CEE6FF",
    stroke: "#328CE1",
    strokeWidth: 0.989584
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M17.5837 32.045C19.1576 32.045 20.4334 30.7691 20.4334 29.1952C20.4334 27.6213 19.1576 26.3454 17.5837 26.3454C16.0098 26.3454 14.7339 27.6213 14.7339 29.1952C14.7339 30.7691 16.0098 32.045 17.5837 32.045Z",
    fill: "#CEE6FF",
    stroke: "#328CE1",
    strokeWidth: 0.989584
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4216 19.1611H24.2729V40.3434H35.4216V19.1611Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7866 44.8384L24.2935 40.3452H35.5239L40.0171 44.8384H28.7866Z",
    fill: "#D1DDEB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.311 34.7737L29.3091 33.5834C28.5379 33.5612 27.7663 33.3417 27.3252 33.0481L27.654 31.894C28.1318 32.1742 28.8199 32.4306 29.5644 32.4294C30.3356 32.4282 30.8625 32.0462 30.8616 31.4577C30.8607 30.906 30.4328 30.5489 29.5243 30.2193C28.2382 29.7565 27.4027 29.166 27.4009 28.0258C27.3993 26.9693 28.1325 26.159 29.3708 25.9364L29.3689 24.7326L30.3738 24.7311L30.3756 25.8713C31.1468 25.8935 31.6746 26.0766 32.0655 26.2732L31.7367 27.4039C31.4427 27.2706 30.9014 26.9872 30.0701 26.9885C29.2121 26.9899 28.9057 27.4317 28.9063 27.8496C28.9071 28.3512 29.3482 28.6347 30.3905 29.051C31.7634 29.5638 32.3754 30.2249 32.3771 31.3183C32.3787 32.3615 31.659 33.2821 30.3106 33.5049L30.3125 34.7688L29.311 34.7704V34.7737Z",
    fill: "#166BCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashbackrewards);
export default __webpack_public_path__ + "static/media/cashbackrewards.acc5d73b3268d05edd57fe74c88964d6.svg";
export { ForwardRef as ReactComponent };